import {
  ChangeEvent,
  useContext,
  useEffect,
  useState
} from 'react';

import { HotelsSearchRoomsContextType, HotelsSearchRoomsContext } from '../../../../contexts/HotelSearchRoomsContextWrapper';

import styles from './HotelFilter.module.scss';

export function HotelFilter() {

  const { filteredHotels, setFilteredHotels , hotelsSearch } = useContext<HotelsSearchRoomsContextType>(HotelsSearchRoomsContext);
  const [ categories,setCategories ] = useState<string[]>([]);
  const [ priceSort, setPriceSort ] = useState<'asc' | 'desc'>('asc');
  const [ category, setCategory ] = useState('');

  useEffect(() => {
    // it is returning an array of categories from the hotels returned from API call, user can choose to filter by category just categories that are in the returned hotels
    setCategories(hotelsSearch.map(hotel => hotel.category))

    // Default hotels sorting order to low-high
    setPriceSort('asc')
    setFilteredHotels([...hotelsSearch].sort((a, b) => +a.price - +b.price))
  },[setCategories, hotelsSearch, setFilteredHotels])

  const handleFilter = ( event: ChangeEvent<HTMLSelectElement>) => {

    const filteredHotels = hotelsSearch.filter(hotel => hotel.category ===  event.target.value);

    // if user selects 'all' then we show all hotels and set category to empty string
    if(event.target.value === 'All'){
      setCategory('')

      // if user selects all the hotels and price is asc then we sort by price asc
      if (priceSort === 'asc'){
        return setFilteredHotels([...hotelsSearch].sort((a,b) => +a.price - +b.price))
      // if user selects all the hotels and price is desc then we sort by price desc
      } else if (priceSort === 'desc') {
        return setFilteredHotels([...hotelsSearch].sort((a,b) => +b.price - +a.price))
      }
      return setFilteredHotels(hotelsSearch)

    // if user selects a category then we filter by category and set category to the selected category
    } else {
      setCategory(event.target.value)

      // if user selects a category and price is asc then we sort by price asc
      if (priceSort === 'asc'){
        return setFilteredHotels([...filteredHotels].sort((a,b) => +a.price - +b.price))
      // if user selects a category and price is desc then we sort by price desc
      } else if (priceSort === 'desc') {
        return setFilteredHotels([...filteredHotels].sort((a,b) => +b.price - +a.price))
      }
      return setFilteredHotels(filteredHotels);
    }
  }

  const handleSortBy = (event: ChangeEvent<HTMLSelectElement>) => {
    // if user selects price asc then we sort by price asc and set priceSort to asc
    if( event.target.value === 'asc') {
      setPriceSort('asc')

      // if user selects price asc and category is not all then we sort the filtered hotels by price asc
      if (category !== '') {
        return setFilteredHotels([...filteredHotels].sort((a,b) => +a.price - +b.price))
      }
      return setFilteredHotels([...hotelsSearch].sort((a,b) => +a.price - +b.price))

    // if user selects price desc then we sort by price desc and set priceSort to desc
    } else if ( event.target.value === 'desc') {
      setPriceSort('desc')

      // if user selects price desc and category is not all then we sort the filtered hotels by price desc
      if (category !== '') {
        return setFilteredHotels([...filteredHotels].sort((a,b) => +b.price - +a.price))
      }
      return setFilteredHotels([...hotelsSearch].sort((a,b) => +b.price - +a.price))
    }
  }

return (
  <div className={styles.filterSection}>
  <div className={styles.filter}>
    <label htmlFor="filter">Filter by</label>
    <select name="filter" id="filter" onChange={handleFilter} className={styles.filterBy}>
      <option value="All">All hotels</option>
      {categories.filter((cat,index) => { return categories.indexOf(cat) === index}).map((category: string, index: number) => <option key={index} value={category}>{category}</option>)}
    </select>
  </div>
  <div className={styles.sort}>
    <label htmlFor="sort-by">Sort by</label>
    <select name="sort-by" id="sort-by" onChange={handleSortBy} defaultValue={'asc'} defaultChecked className={styles.sortBy}>
      <option value="asc" >Price: Low to High</option>
      <option value="desc" >Price: High to Low</option>
    </select>
  </div>
  </div>
  )
}
